import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class TaskStatusService extends BaseService {
  protected baseUrl = '/finance/brs/task-status';
}
